import styled from "styled-components";
import Main from "./Main";
import * as Variables from "../globalStyles/Variables";
import { Suspense } from "react";
import Loading from '../components/sections/Loading';

const AppContainer = styled.div`
  position: relative;
  overflow: hidden;
  z-index: ${Variables.zIndex.one};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export default function App() {

  return (
    <Suspense fallback={<Loading />}>
      <AppContainer>
        <Main />
      </AppContainer>
    </Suspense>

  );
}
